import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { TagsServiceProvider } from '../../api/tags'

const TagsService = TagsServiceProvider()
const name = 'getTags'

export default () => (asyncAction(
  name,
  TagsService.getTags
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/tags/getTags.js